import React, { useCallback, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { WarehouseAdditionalLayout } from "../../../common/Layouts";

function EdiDefaultTab(props) {
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const handleCodesFormLoad = useCallback(() => {
        props.additonalFormLookupsLoad(formRefs);
    }, []);


    const handleFieldChange = useCallback((name, value, e) => {
    }, []);



    return (
        <div className="FormMt">
            <FormField
                currrentUser={currentUser}
                layoutId='7C9212EE-39FC-401B-BD33-81B206642810'
                layoutName='WarehouseAdditinalTab'
                defaultFormSchema={WarehouseAdditionalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handleCodesFormLoad}
            />
        </div>

    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(EdiDefaultTab);
